import { Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter, tap } from 'rxjs';
import {
  NavigationItem,
  RoutePath,
} from '../interfaces/navigationList.interface';
import { FiltersLocation } from '../interfaces/region.interface';
import { HomeButtonConfig } from '../interfaces/PageContainerConfiguration.interface';

@Injectable({
  providedIn: 'root',
})
export class PageContainerService {
  private navigationList: NavigationItem[] = [];
  private routePath: RoutePath[] = [];
  activeSectionRoute = new BehaviorSubject<NavigationItem | null>(null);
  menuExpanded = new BehaviorSubject<boolean>(false);
  resetRouting$ = new BehaviorSubject<any>(null);
  changeTab$ = new BehaviorSubject<NavigationItem | null>(null);
  selectLastChild$ = new BehaviorSubject<NavigationItem | null>(null);
  selectedLocations$ = new BehaviorSubject<FiltersLocation[]>([]);
  standAlonePageTitle = signal<string | null>(null);
  homePageConfig = signal<HomeButtonConfig | null>(null);

  expandMenuDrawer$ = new BehaviorSubject<boolean>(false);
  expandFilterDrawer$ = new BehaviorSubject<boolean>(false);

  routerEvent$ = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    tap(event => {
      this.getActiveRoute(event);
    }),
  );

  constructor(readonly router: Router) {
    this.routerEvent$.subscribe();
  }

  setNavigationList(navigationList: NavigationItem[]) {
    this.navigationList = navigationList;
  }

  getNavigationList(): NavigationItem[] {
    return this.navigationList;
  }

  setRoutePath(routePath: RoutePath[]) {
    this.routePath = routePath;
  }

  getRoutePath(): RoutePath[] {
    return this.routePath;
  }

  private getActiveRoute(event: NavigationEnd) {
    this.resetRouting$.next(null);
    this.resetRouting();

    const cleanUrl = event.urlAfterRedirects.split('?')[0];

    // Try exact match first
    let currentRoutePath = this.routePath.find(
      x => x.url === cleanUrl,
    )?.routePath;

    // Fallback for /dispatch pages
    if (!currentRoutePath && cleanUrl.includes('/dispatch')) {
      currentRoutePath = [1, 6]; // "Rides" parent and "Active Rides" child
    }

    if (currentRoutePath) {
      const index = this.navigationList.findIndex(
        x => x.id === currentRoutePath[0],
      );

      if (index !== -1) {
        this.activeSectionRoute.next(this.navigationList[index]);
        this.standAlonePageTitle.set(this.navigationList[index].name);
      } else {
        throw new Error('Route id not found');
      }
    } else if (cleanUrl === '/dashboard') {
      this.standAlonePageTitle.set('Dashboard');
    } else {
      this.standAlonePageTitle.set(null);
    }
  }

  resetRouting() {
    this.activeSectionRoute.next(null);
    this.resetRouting$.next(null);
  }
}
